import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { getHeaderHeights } from '../components/navigation/header/header.utils';
import { BaseUnit } from '../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

const componentConfigThemeKey = 'main';

interface MainTagThemeProps {
  baseUnit: BaseUnit;
  backgroundColor: string;
}

interface MainWrapperProps {
  isSecondaryHeaderEnabled: boolean;
  configThemeKey?: string;
}

export const MainWrapper: React.FunctionComponent<MainWrapperProps> = ({ isSecondaryHeaderEnabled, children, configThemeKey }) => {
  const { baseUnit, backgroundColor } = useTheme<MainTagThemeProps>(configThemeKey || componentConfigThemeKey);
  const headerHeights = getHeaderHeights(isSecondaryHeaderEnabled);

  const style = {
    backgroundColor,
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `${headerHeights.large + baseUnit / 4}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingTop: `${headerHeights.medium + baseUnit / 4}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingTop: `${headerHeights.small + baseUnit / 4}px`,
    },
  };

  return (
    <main
      className={css(StyleSheet.create({ style }).style)}
    >
      {children}
    </main>
  );
};
